var path = 'src/app/components/technical/working-day-cache-refresher/working-day-cache-refresher.template.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;